
import React, { useState, useEffect } from "react";
import HeroSection from "./EvangelismAssistant/HeroSection";
import ChatInterface from "./EvangelismAssistant/ChatInterface";
import { WorldviewSelector } from "./EvangelismAssistant/WorldviewSelector";
import { EvangelismAssistantProvider } from "./EvangelismAssistant/EvangelismAssistantProvider";
import WorldviewInstructionsDialog from "./EvangelismAssistant/WorldviewInstructionsDialog";

const EvangelismAssistantTool = () => {
  const [selectedWorldview, setSelectedWorldview] = useState<string | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  
  // Force render when component mounts to ensure visibility in full-screen mode
  useEffect(() => {
    // Short delay to ensure DOM is ready
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Show dialog after worldview is selected
  useEffect(() => {
    if (selectedWorldview) {
      setOpenDialog(true);
    }
  }, [selectedWorldview]);

  const handleStartConversation = () => {
    setOpenDialog(false);
  };
  
  const handleReset = () => {
    setSelectedWorldview(null);
    setOpenDialog(false);
  };
  
  return (
    <div className="max-w-5xl mx-auto pb-12">
      <EvangelismAssistantProvider>
        <HeroSection />
        
        {/* Worldview Instructions Dialog - shown after worldview selection */}
        <WorldviewInstructionsDialog 
          open={openDialog}
          onOpenChange={setOpenDialog}
          worldview={selectedWorldview}
          onStartConversation={handleStartConversation}
        />
        
        {!selectedWorldview ? (
          <WorldviewSelector onWorldviewSelect={setSelectedWorldview} />
        ) : (
          <ChatInterface worldview={selectedWorldview} onReset={handleReset} />
        )}
      </EvangelismAssistantProvider>
    </div>
  );
};

export default EvangelismAssistantTool;
